// src/context/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
// import { auth } from '../firebase'; // adjust path to your firebase.js
import { auth } from '../firebase'; // adjust path to your firebase.js
import { onAuthStateChanged, signOut } from 'firebase/auth';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState('guest'); // 'user', 'moderator', 'admin', etc.

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);

      if (user) {
        // Get custom claims (roles) from ID token
        const idTokenResult = await user.getIdTokenResult();
        const role = idTokenResult.claims.role || 'user';
        setUserRole(role);
      } else {
        setUserRole('guest');
      }

      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const logout = () => signOut(auth);

  const value = {
    currentUser,
    userRole,
    isAdmin: userRole === 'admin',
    isModerator: userRole === 'moderator' || userRole === 'admin',
    isAuthenticated: !!currentUser,
    loading,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);